<template>
	<div class="abel publications photography">
		<DetailsComponent :article="article"/>
		<p>{{ article.excerpt }}</p>
		<div>
			<Photogrid src="https://thelinknewspaper.ca/" :images="article.images"/>
			<!-- <img v-for="img in article.images" :src="`https://thelinknewspaper.ca/${img}`"/> -->
			<!-- {{ article.images }} -->
		</div>
		<!-- <div class="row">
			<div class="col">
				<CardArticleComponent v-for="s in suggested" :article="s"/>
			</div>
		</div> -->
	</div>
</template>
<script setup>
import { useRoute } from 'vue-router'
import { computed, onMounted, ref } from "vue";

import publications from "@/data/articles.json";
import CardArticleComponent from '../components/CardArticleComponent.vue';
import Photogrid from '../components/photography/photogrid.vue';
import DetailsComponent from '../components/publications/DetailsComponent.vue';

const route = useRoute()

const sorted_publications = computed(() => {
	return publications.sort((a, b) => new Date(a) - new Date(b));
});
console.log(route.params)
const article = ref(publications.filter(e => e.slug == route.params.slug)[0]);
const suggested = computed(() => {
	return sorted_publications.value.filter(pub => pub.section.toLowerCase() == route.params.section).filter(pub => pub.slug != article.value.slug && pub.slug != route.params.slug).slice(0,5);
})
</script>